var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgForumDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "g825",
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_23",
    d: "M0,0H64V64H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M298.832,90.856a18,18,0,1,1,5.946,5.946l-5.81,2.49a2,2,0,0,1-2.626-2.626Zm3.156,2.79,2.2-.943a2,2,0,0,1,1.94.2,14,14,0,1,0-3.4-3.4,2,2,0,0,1,.2,1.94Z",
    transform: "translate(-272.182 -57.455)",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M536,374v-2a2,2,0,0,1,4,0v4a2,2,0,0,1-2,2H486a2,2,0,0,1-2-2V340a2,2,0,0,1,2-2h20.505a2,2,0,0,1,1.937,2.5,14.018,14.018,0,0,0,2.106,11.551,2,2,0,0,1,.2,1.94l-.943,2.2,2.2-.943a2,2,0,0,1,1.94.2A14,14,0,0,0,536,344a2,2,0,1,1,4,0v20a2,2,0,0,1-4,0v-8.693a17.99,17.99,0,0,1-23.4,4.041l-5.81,2.49a2,2,0,0,1-2.626-2.626l2.49-5.81A17.9,17.9,0,0,1,504,344a18.1,18.1,0,0,1,.11-2H488v32Z",
    transform: "translate(-480 -320)",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M512.745,333.5a2,2,0,0,0-1.324-3.5H490a6,6,0,0,0-6,6v4a2,2,0,0,0,2,2h20.505a2,2,0,0,0,1.937-1.5,14,14,0,0,1,4.3-7Zm-5.71.5H490a2,2,0,0,0-2,2v2h17.027a17.927,17.927,0,0,1,2.008-4Z",
    transform: "translate(-480 -320)",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M189-27a1,1,0,0,0,1-1v-2a1,1,0,0,0-1-1h-2a1,1,0,0,0-1,1v2a1,1,0,0,0,1,1Z",
    transform: "translate(238 -5) rotate(180)",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M189-27a1,1,0,0,0,1-1v-2a1,1,0,0,0-1-1h-2a1,1,0,0,0-1,1v2a1,1,0,0,0,1,1Z",
    transform: "translate(230 -5) rotate(180)",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M189-27a1,1,0,0,0,1-1v-2a1,1,0,0,0-1-1h-2a1,1,0,0,0-1,1v2a1,1,0,0,0,1,1Z",
    transform: "translate(222 -5) rotate(180)",
    fill: "#fff",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgForumDark);
export default __webpack_public_path__ + "static/media/forum_dark.a8d4dcf06f7f4d5b6a60e94e91d605ad.svg";
export { ForwardRef as ReactComponent };